import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { kueskiAttribution } from '@kueski-dev/web-observability';
import useMerchantPaymentQuery from 'Hooks/useMerchantPaymentQuery';
import Urls from 'Containers/Urls';

const FINISHED_PATHS = [Urls.loan, Urls.rejected, Urls.authorized];

export const PaymentTracker: React.FC = ({ children }) => {
  const { data, isLoading } = useMerchantPaymentQuery({
    enabled: true,
    refetchOnMount: true,
  });
  const { pathname } = useLocation();

  const shouldClear = useMemo(() => FINISHED_PATHS.includes(pathname), [pathname]);
  const merchantId = data?.payment?.merchantId ?? '';

  useEffect(() => {
    if (isLoading) return;

    if (shouldClear) {
      kueskiAttribution.update({ merchant_id: '' });
    } else {
      kueskiAttribution.update({ merchant_id: merchantId });
    }
  }, [merchantId, isLoading, shouldClear]);

  return <>{children}</>;
};
